<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Judith Barclay was born and bred in Goodwick, Pembrokeshire. She has a degree in education from the University of Nottingham and started writing seriously after retiring from a career in teaching. She enjoys walking, reading psychological thrillers and has travelled extensively all over Europe, and in Africa and Asia. She has held a lifelong passion for Italy and all things Italian and was inspired to write this book by her research into the history of the mass immigration and integration of Italians into Wales from the late nineteenth century. Judith has twin daughters, Emily and Joanna, and lives in Derbyshire with her husband, Chris.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7b79a384